export const logo = require('./otaku-logo.png');
